import { gql } from '@apollo/client';

const Fragments = {
  dictionaryItem: gql`
    fragment dictionaryItem on DictionaryItem {
      id
      code
      name
      isActive
      isSystem
    }
  `,

  genericDictionaryItem: gql`
    fragment genericDictionaryItem on DictionaryItem {
      description
      implicit
      orderNo
      ...dictionaryItem
    }
  `
};

export default Fragments;
